import { EnumeratedSetValue, IEnumeration } from 'utility-js-enumeration';
import { MajorDataToggleService } from '../services/major_data_toggle_service';
import { MajorProgram } from './../builders/major_programs_builder';

declare var Enumeration: IEnumeration;

const customSortPartial = (key: string, rank: object) => (major: MajorProgram) => rank[major[key]];

export function ProgramSortEnum(majorDataToggleService: MajorDataToggleService) {
  return Enumeration.useDefinitionAsEnum({
    rank: {
      actionSheetText: 'Fit (Best Match)',
      displayText: 'Best Match',
      sortOrder: 'asc',
      enabled: () => {
        return true;
      }
    },
    name: {
      actionSheetText: 'Name',
      displayText: 'Name',
      sortOrder: 'asc',
      enabled: () => {
        return true;
      }
    },
    credits: {
      actionSheetText: 'Credits',
      displayText: 'Credits',
      sortOrder: 'desc',
      enabled: () => {
        return majorDataToggleService.toggles.credits;
      }
    },
    _salary_trend_min_sort: {
      actionSheetText: 'Salary',
      displayText: 'Salary',
      sortOrder: 'desc',
      enabled: () => {
        return majorDataToggleService.toggles.salary;
      }
    },
    hiring_demand: {
      actionSheetText: 'Hiring Demand',
      displayText: 'Hiring Demand',
      sortOrder: 'desc',
      customSortMethod: customSortPartial('hiring_demand', {
        'Very High': 5,
        High: 4,
        Medium: 3,
        Low: 2,
        'Very Low': 1,
        '': 0
      }),
      enabled: () => {
        return majorDataToggleService.toggles.hiringDemand;
      }
    }
  });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/types/program_sort_enum.ts